import { IUser } from 'features/auth/types'

// types
export enum StorageEnum {
  currentUser = 'currentUser',
  userWorkEmail = 'userWorkEmail',
  oaiCurrentTenant = 'outbound-ai-preferred-tenant',
  microphoneDevideId = 'microphoneDevideId',
  keycloakRealm = 'keycloakRealm',
}

type StorageKeysType = keyof typeof StorageEnum

interface IStorageParams {
  [StorageEnum.currentUser]: IUser
  [StorageEnum.userWorkEmail]: string
  [StorageEnum.oaiCurrentTenant]: string
  [StorageEnum.microphoneDevideId]: string
}

const set = <K extends StorageKeysType>(
  key: K,
  data: K extends keyof IStorageParams ? IStorageParams[K] : void,
): void => {
  localStorage.setItem(key, JSON.stringify(data))
}

const get = <K extends StorageKeysType>(key: K): K extends keyof IStorageParams ? IStorageParams[K] : null => {
  const data = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)!) : null

  return data
}

const remove = <K extends StorageKeysType>(key: K): void => {
  localStorage.removeItem(key)
}

const storage = {
  remove,
  set,
  get,
}

export default storage
